import { useLocation, Navigate } from 'react-router-dom';
import { useContext } from 'react';
import LinearLoader from "components/Loader/LinearLoader";
import UserContext from 'contexts/UserContext';

function Fallback() {
    const location = useLocation();
    const { currentPromo } = useContext(UserContext);

    // Se ainda não temos promo, só mostra o loader
    if (!currentPromo) {
        return <LinearLoader />;
    }

    // Preserva querystring e hash no redirect
    const to = `/${currentPromo.path}${location.pathname}${location.search}${location.hash}`;
    return <Navigate to={to} replace />;
}

export default Fallback;
